<template>
  <span
    :class="{
      wait: newValue === 0,
      doing: newValue === 1,
      finish:newValue === 2,
    }"
  >
    {{ value }}
  </span>
</template>

<script>
  export default {
    name: "StateBox",
    props: {
      value: {
        type: String,
        default: "",
      },
    },
    computed: {
      status() {
        return this.enum[this.newValue];
      },
      newValue() {
        let value = null;
        const v = this.value;
        if (this.isBingo(["待完成", "失败", "待更新", "放弃"], v)) {
          value = 0;
        } else if (this.isBingo(["正在更新", "更新中", "中", "准备"], v)) {
          value = 1;
        } else if (this.isBingo(["更新完成", "已更新", "成功", "完成"], v)) {
          value = 2;
        }
        return value;
      },
    },
    methods: {
      // 判断是否存在
      isBingo(arr, value) {
        let state = false;
        arr.map((v) => {
          if (value.indexOf(v) !== -1) {
            state = true;
          }
        });
        return state;
      },
    },
  };
</script>

<style scoped>
.wait{color: red;}
.doing{color:#FFCC00;}
.finish{color: green;}
</style>
